/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placeheaderrating2Inputs */

const en_placeheaderrating2 = /** @type {(inputs: Placeheaderrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rating`)
};

const de_placeheaderrating2 = /** @type {(inputs: Placeheaderrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewertung`)
};

/**
* | output |
* | --- |
* | "Rating" |
*
* @param {Placeheaderrating2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placeheaderrating2 = /** @type {((inputs?: Placeheaderrating2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placeheaderrating2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placeheaderrating2(inputs)
	return de_placeheaderrating2(inputs)
});
export { placeheaderrating2 as "placeHeaderRating" }